import React from "react";

const InCompleteTask = () => {
    const incompleteTaskList = [
        {
          id: 12,
          task1: "Put away wholesaler Order",
          taskContent: "Recurring ",
        },
        {
          id: 13,
          task1: "Preventative Maintenance for ScriptPro",
          taskContent: "Recurring ",
        },
        {
          id: 14333,
          task1: "Catch up on patient adherence calls",
          taskContent: "One-Time Only ",
        },
        {
          id: 15333,
          task1: "Restock supplies",
          taskContent: "Recurring  ",
        },
        {
          id: 1633,
          task1: "Complete HIPAA training module (all staff)",
          taskContent: "One-Time Only",
        },
        {
            id: 12333,
            task1: "Put away wholesaler Order",
            taskContent: "Recurring ",
          },
          {
            id: 13333,
            task1: "Preventative Maintenance for ScriptPro",
            taskContent: "Recurring ",
          },
          {
            id: 14333,
            task1: "Catch up on patient adherence calls",
            taskContent: "One-Time Only ",
          },
          {
            id: 153333,
            task1: "Restock supplies",
            taskContent: "Recurring  ",
          },
          {
            id: 162333,
            task1: "Complete HIPAA training module (all staff)",
            taskContent: "One-Time Only",
          },
          {
            id: 12,
            task1: "Put away wholesaler Order",
            taskContent: "Recurring ",
          },
          {
            id: 13999,
            task1: "Preventative Maintenance for ScriptPro",
            taskContent: "Recurring ",
          },
          {
            id: 14999,
            task1: "Catch up on patient adherence calls",
            taskContent: "One-Time Only ",
          },
          {
            id: 9999,
            task1: "Restock supplies",
            taskContent: "Recurring  ",
          },
          {
            id: 1699999,
            task1: "Complete HIPAA training module (all staff)",
            taskContent: "One-Time Only",
          },     {
            id: 1288,
            task1: "Put away wholesaler Order",
            taskContent: "Recurring ",
          },
          {
            id: 1377,
            task1: "Preventative Maintenance for ScriptPro",
            taskContent: "Recurring ",
          },
          {
            id: 4555,
            task1: "Catch up on patient adherence calls",
            taskContent: "One-Time Only ",
          },
          {
            id: 15123,
            task1: "Restock supplies",
            taskContent: "Recurring  ",
          },
          {
            id: 16333,
            task1: "Complete HIPAA training module (all staff)",
            taskContent: "One-Time Only",
          },
          {
            id: 15331,
            task1: "Restock supplies",
            taskContent: "Recurring  ",
          },
          {
            id: 1633,
            task1: "Complete HIPAA training module (all staff)",
            taskContent: "One-Time Only",
          },
      ];
  return (
    <div style={{ width: "42vw", padding: "16px", cursor: "pinter" }}>
    <div
          className="bg-white border-radius-8 "
        //   style={{ width: "50%", border: "1px solid #D3D3D3" }}
        >
          <div className="p-r-16">
            {/* <h1 className="overview-text">Incomplete Tasks (23)</h1> */}
            {/* <hr style={{ color: "#D3D3D3" }} /> */}
          </div>
          {incompleteTaskList.map((t) => (
            <div key={t.id} className=" p-r-16 ">
              <div className="mb-2">
                <h4 className="dash-name">{t.task1}</h4>
                <h5 className="min">{t.taskContent} </h5>
              </div>
            </div>
          ))}
        
        </div>
   
    </div>
  );
};

export default InCompleteTask;
